import React from "react";
import { get } from "react-hook-form";
import ErrorBlock from "./error";

const FormInput = ({
  name,
  label,
  register,
  error,
  containerClass = "input-fields",
  placeholder,
  registerOptions,
  text,
  type = "text",
  ...rest
}) => {
  return (
    <div className={containerClass} >
      <label className="input-label" htmlFor={name}>{label}</label>
      {
        text &&
        <p>
          <small className="form-text text-muted">{text}</small>
        </p>
      }
      {(type === "file") ? <input className="input-upload" id={name} type={type} placeholder={placeholder} {...register(name, { ...registerOptions })} {... {accept: "image/jpeg, image/png, .heic, .heif, image/svg+xml" }} {...rest} /> : <input id={name} type={type} placeholder={placeholder} {...register(name, { ...registerOptions })} {...rest} />}
      {error && <ErrorBlock error={error} />}
    </div >
  )
};

FormInput.displayName = "InputText";


export const renderInput = (
  name,
  errors,
  register,
  { type, label, placeholder, registerOptions, text, containerClass }) =>

  <FormInput
    containerClass={containerClass}
    type={type}
    name={name} label={label} text={text}
    placeholder={placeholder}
    error={get(errors, name)?.message}
    register={register}
    registerOptions={registerOptions}
  />

export default FormInput
